import React from 'react'
import Formsy from 'formsy-react'
import createReactClass from 'create-react-class'

const BVTextArea = createReactClass({

	// Add the Formsy Mixin
	mixins: [Formsy.Mixin],

	// setValue() will set the value of the component, which in
	// turn will validate it and the rest of the form
	changeValue(event) {
		let value = event.currentTarget.value
		this.setValue(event.currentTarget[this.props.type === 'checkbox' ? 'checked' : 'value'])
	},
	render() {

		// Set a specific className based on the validation
		// state of this component. showRequired() is true
		// when the value is empty and the required prop is
		// passed to the input. showError() is true when the
		// value typed is invalid
		const className = (this.props.className || ' ') +
      (this.showRequired() ? 'required' : this.showError() ? 'error' : '')

		// An error message is returned ONLY if the component is invalid
		// or the server has returned an error message
		const errorMessage = this.getErrorMessage()
		const { title, icon } = this.props

		return (
			<div className={className}>
				{ title ? <label htmlFor={this.props.name} className="bv-form-label">{ title }</label> : <label htmlFor={this.props.name} className="bv-form-label">&nbsp;</label> }
				{ icon ? <i className={icon}></i> : null }
				<textarea
					type={this.props.type || 'text'}
					name={this.props.name}
					onChange={this.changeValue}
					value={this.getValue() || ""}
					className="bv-form-element"
					placeholder={this.props.placeholder}
					style={this.props.style}
					rows={this.props.rows || "7"}
					required={this.props.required || false}
				/>
				<span className='validation-error'>{errorMessage}</span>
			</div>
		)
	}
})

export default BVTextArea

